import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

//Custom Components

import Home from "../pages/home";
import Header from "../components/Layout/Header";
import About from "../pages/about";
import Blog from "../pages/blog";
import BlogDetails from "../pages/blog/blog-details";
import Services from "../pages/service";
import ServiceDetails from "../pages/service/service-details";
import Contact from "../pages/contact";
import Error from "../pages/404";
import LoadTop from "../components/Common/ScrollTop/LoadTop";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setBanner,
  setPage,
  setService,
  setTeam,
  setTestimonial,
  setProducts,
  setsiteSetting,
} from "../store/slice";
import Loader from "../Loader";
import axios from "axios";
import { BASE_URL } from "../Service";
// import Team from "../pages/team";
// import TeamDetails from "../pages/team/team-details";

const App = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const headers = {
      "Content-Type": "application/json",
      domain: "techniajz.com",
    };
    const fetchData = async () => {
      try {
        const siteSettingRes = await axios.get(
          `${BASE_URL}/api/v1/siteSetting/get`,
          { headers }
        );

        if (siteSettingRes.data.success) {
          dispatch(setsiteSetting(siteSettingRes.data.data));
        }

        const [
          bannerRes,
          pageRes,
          serviceRes,
          teamRes,
          testimonialRes,
          productRes,
        ] = await Promise.all([
          axios.get(`${BASE_URL}/api/v1/banner`, { headers }),
          axios.get(`${BASE_URL}/api/v1/page`, { headers }),
          axios.get(`${BASE_URL}/api/v1/service`, { headers }),
          axios.get(`${BASE_URL}/api/v1/team`, { headers }),
          axios.get(`${BASE_URL}/api/v1/testimonials`, { headers }),
          axios.get(`${BASE_URL}/api/v1/product`, { headers }),
        ]);

        if (bannerRes.data.success) dispatch(setBanner(bannerRes.data.data));
        if (pageRes.data.success) dispatch(setPage(pageRes.data));
        if (serviceRes.data.success) dispatch(setService(serviceRes.data.data));
        if (teamRes.data.success) dispatch(setTeam(teamRes.data.data));
        if (productRes.data.success)
          dispatch(setProducts(productRes.data.data));
        if (testimonialRes.data.success)
          dispatch(setTestimonial(testimonialRes.data.data));
        setLoading(false);
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="App">
      <Router>
        <Header parentMenu="home" secondParentMenu="multipage" activeMenu="" />
        <LoadTop />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/home" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/service" exact component={Services} />
          <Route path="/service/:id" exact component={ServiceDetails} />
          <Route path="/blog" exact component={Blog} />
          <Route path="/blog/blog-details" component={BlogDetails} />
          <Route path="/contact" component={Contact} />
          <Route component={Error} />
          {/* <Route path="/team" exact component={Team} /> */}
          {/* <Route path="/team/team-details" component={TeamDetails} /> */}
        </Switch>
      </Router>
    </div>
  );
};

export default App;
